import "../Resources/Css/layout/header.css";
import "../Resources/Css/common.css";
import "../Resources/Js/common_func.js";
import "./header_dropdown-jq.js";
import { useEffect, useState, useRef } from "react";
import { ToggleChatShow } from "../Resources/Js/sub.js";
import { FaqForChatbot } from "./Api/callData.js";
import { Link } from "react-router-dom";
import { LogoutSession } from "./Api/login.js";

export function Header() {
  const [isChabotVisible, setIschatbotVisible] = useState(false);
  const [messages, setMessages] = useState([]);
  const [isAnswer, setIsAnswer] = useState(false);
  const [changeLogo, setChangeLogo] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [login, setLogin] = useState(false);
  const [logout, setLogout] = useState(false);
  const chatRef = useRef(null);
  const lastUserMsgRef = useRef(null);

  const bRadius0 =
    login === true
      ? {
          borderRadius: "0",
        }
      : {};

  // 로그아웃 버튼 드러내기
  useEffect(() => {
    const local = localStorage.length;
    if (local > 0) {
      setLogin(true);
    }
  }, []);

  // 로그아웃 실행
  const handleLogout = () => {
    setLogout(true);
  };
  useEffect(() => {
    if (logout != false) {
      LogoutSession(logout);
    }
  }, [logout]);

  const toggleLogo = () => {
    setChangeLogo((prev) => !prev);
    setMenuOpen((prev) => !prev);
  };

  const toggleChatbot = () => {
    setIschatbotVisible((prev) => !prev);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // 모바일 키보드/주소창 변화에 맞춰 챗봇 위치·높이 보정 (iOS Safari 등)
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;
    const root = document.documentElement;
    const update = () => {
      root.style.setProperty("--vvh", `${vv.height}px`);
      root.style.setProperty("--vvw", `${vv.width}px`);
      root.style.setProperty("--vv-top", `${vv.offsetTop}px`);
      const kb = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      root.style.setProperty("--kb", `${kb}px`);
    };
    update();
    vv.addEventListener("resize", update);
    vv.addEventListener("scroll", update);
    return () => {
      vv.removeEventListener("resize", update);
      vv.removeEventListener("scroll", update);
    };
  }, []);

  // 모바일에서 챗봇 열렸을 때 body 스크롤 잠금 — iOS Safari가 입력창 포커스 시
  // 레이아웃 뷰포트를 위로 스크롤시켜 시트가 깨지는 문제 방지
  useEffect(() => {
    if (!isChabotVisible) return;
    if (!window.matchMedia("(max-width: 640px)").matches) return;
    const scrollY = window.scrollY;
    const body = document.body;
    const prev = {
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
    };
    body.style.position = "fixed";
    body.style.top = `-${scrollY}px`;
    body.style.left = "0";
    body.style.right = "0";
    body.style.width = "100%";
    return () => {
      body.style.position = prev.position;
      body.style.top = prev.top;
      body.style.left = prev.left;
      body.style.right = prev.right;
      body.style.width = prev.width;
      window.scrollTo(0, scrollY);
    };
  }, [isChabotVisible]);

  // faq 데이터를 불러와서 받아야 함
  useEffect(() => {
    if (messages.length == 0) {
      const fetchData = async () => {
        const result = await FaqForChatbot();
        // console.log(result);
        setMessages(Array.isArray(result) ? result : []);
      };
      fetchData();
    }
  }, [messages.length]);

  // ✅ 문자열 유사도(Levenshtein 거리) 계산 함수
  function levenshtein(a, b) {
    const matrix = Array.from({ length: a.length + 1 }, () =>
      Array(b.length + 1).fill(0)
    );
    for (let i = 0; i <= a.length; i++) matrix[i][0] = i;
    for (let j = 0; j <= b.length; j++) matrix[0][j] = j;
    for (let i = 1; i <= a.length; i++) {
      for (let j = 1; j <= b.length; j++) {
        const cost = a[i - 1] === b[j - 1] ? 0 : 1;
        matrix[i][j] = Math.min(
          matrix[i - 1][j] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j - 1] + cost
        );
      }
    }
    return matrix[a.length][b.length];
  }

  // ✅ 입력값과 Firestore FAQ title 간 유사도 계산 후 가장 유사한 항목을 반환
  function getBestMatch(input, candidates) {
    input = input.toLowerCase();
    let best = null;
    let minDistance = Infinity;

    for (const msg of candidates) {
      if (!msg.title) continue;
      const dist = levenshtein(input, msg.title.toLowerCase());
      if (dist < minDistance) {
        minDistance = dist;
        best = msg;
      }
    }

    console.log('minDistance : ', minDistance)
    if (minDistance === 0) {
      best.clickFaq = true
    } else {
      best.clickFaq = false
    }

    // ✅ 가장 유사한 제목 길이의 80%까지 허용, 최소 15)
    const threshold = Math.max(15, Math.floor(best.title.length * 0.8));
    if (minDistance > threshold) return null;

    return best;
  }

  // ✅ 클릭형 또는 입력형 공통 처리 함수
  const handleQuestionAnswer = (inputText) => {
    const answer = getBestMatch(inputText, messages); // faqList에서만 찾는 걸 추천

    // 유저 입력 메시지 추가
    const userInputMsg = { text: inputText, type: "user" };

    // 유사한 title 메시지 (유저 표현으로 보이게)
    if (answer) {
      console.log('!answer.clickFaq : ', !answer.clickFaq)
    }
    const matchedTitleMsg = answer && !answer.clickFaq
      ? { text: answer.title, type: "user", sub: true } // sub=true 로 스타일 분기 가능
      : null;

    const botReplyMsg = {
      text: answer
        ? answer.content
        : "Sorry, I couldn't find an answer.",
      type: "bot",
    };

    setMessages((prev) => [
      ...prev,
      userInputMsg,
      ...(matchedTitleMsg ? [matchedTitleMsg] : []),
    ]);

    setTimeout(() => {
//      setMessages((prev) => [...prev, botReplyMsg]);
      setMessages((prev) => {
        const updated = [...prev];

        // 1. 봇 응답 추가
        updated.push(botReplyMsg);

        // 2. 답변이 없을 경우 FAQ 버튼 목록도 이어붙임
        if (!answer) {
          const faqButtons = messages
            .filter((msg) => msg.title && msg.type == null)
            .map((msg) => ({
              title: msg.title,
              type: "faq", // 📌 렌더링 구분용
            }));
          updated.push(...faqButtons); // ⬅ 바로 뒤에 붙이기
        }

        return updated;
      });

      if (!answer) {
        // 스크롤
        setTimeout(() => {
          lastUserMsgRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }, 0);
      } else {
        // 스크롤
        setTimeout(() => {
          lastUserMsgRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }, 0);
      }
    }, 800);
  };

  // ✅ 클릭형 질문 핸들러 → 공통 함수 호출
  const handleQuestionMessage = (title) => {
    handleQuestionAnswer(title);
  };

  return (
    <>
      <header className={menuOpen ? "" : "act"} id="header">
        <div className="container">
          <a className="main_logo" href="/">
            <img
              src={`/images/${
                !changeLogo ? "main_logo.png" : "main_logo2.png"
              }`}
            />
          </a>
          {/* Navigation */}
          <nav id="main_menu">
            <ul>
              <li>
                <p>Company</p>
                <ul className="main_dropdown">
                  <li>
                    <Link to="/AboutUs/greetings">Greetings</Link>
                  </li>
                  <li>
                    <Link to="/AboutUs/vision">Vision and Core Values</Link>
                  </li>
                  <li>
                    <Link to="/AboutUs/history">History</Link>
                  </li>
                  <li>
                    <Link to="/AboutUs/map">Map</Link>
                  </li>
                </ul>
              </li>
              <li>
                <p>Business</p>

                <ul className="main_dropdown">
                  <li>
                    <Link to="/Business/b-playground">
                      Brain Health Playground
                    </Link>
                  </li>
                  <li>
                    <Link to="/Business/cogame">Cogame</Link>
                  </li>
                  <li className="blank_menu"></li>
                  <li className="blank_menu"></li>
                  <li className="blank_menu"></li>
                </ul>
              </li>
              <li>
                <p>Community</p>
                <ul className="main_dropdown">
                  <li>
                    <Link to="community/inform">Inform</Link>
                    {/* <a href="community/inform">공지사항</a> */}
                  </li>
                  <li>
                    <Link to="community/news">News</Link>
                    {/* <a href="community/news">언론보도</a> */}
                  </li>
                  <li>
                    <Link to="community/hiring">Recruitment</Link>
                    {/* <a href="community/hiring">채용공고</a> */}
                  </li>
                  <li className="blank_menu"></li>
                  <li className="blank_menu"></li>
                </ul>
              </li>
              <li>
                <p>Support</p>
                <ul className="main_dropdown">
                  <li>
                    <Link to="support/faq">FAQ</Link>
                    {/* <a href="support/faq">FAQ</a> */}
                  </li>
                  <li>
                    <Link to="support/inquiry">Inquiry</Link>
                    {/* <a href="support/inquiry">온라인 문의</a> */}
                  </li>
                  {localStorage.length > 0 ? (
                    <li>
                      <Link to="/popup">Popup</Link>
                    </li>
                  ) : (
                    <li className="blank_menu"></li>
                  )}

                  <li className="blank_menu"></li>
                  <li className="blank_menu"></li>
                </ul>
              </li>
            </ul>
          </nav>
          {/* SNS button */}
          <nav>
            <ul id="main_top_sns">
              <li className="hamWrapper">
                <button
                  type="button"
                  onClick={toggleLogo}
                  aria-label="Toggle menu"
                  style={{
                    background: "none",
                    border: 0,
                    padding: 0,
                    cursor: "pointer",
                    width: 48,
                    height: 48,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <svg
                    className={`ham hamRotate${menuOpen ? " active" : ""}`}
                    viewBox="0 0 100 100"
                    width="45"
                    style={{ pointerEvents: "none" }}
                  >
                    <path
                      className="line top"
                      d="m 30,33 h 40 c 3.722839,0 7.5,3.126468 7.5,8.578427 0,5.451959 -2.727029,8.421573 -7.5,8.421573 h -20"
                    />
                    <path className="line middle" d="m 30,50 h 40" />
                    <path
                      className="line bottom"
                      d="m 70,67 h -40 c 0,0 -7.5,-0.802118 -7.5,-8.365747 0,-7.563629 7.5,-8.634253 7.5,-8.634253 h 20"
                    />
                  </svg>
                </button>
              </li>
            </ul>
          </nav>
        </div>
        <div className={`dropdown-menu${menuOpen ? " active" : ""}`}>
          <button
            type="button"
            className="dropdown-close"
            onClick={toggleLogo}
            aria-label="Close menu"
          >
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.4"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden
            >
              <path d="M18 6 6 18M6 6l12 12" />
            </svg>
          </button>
          <ul>
            <li>
              <span>Company</span>
              <ul>
                <li>
                  <a href="/aboutUs/greetings">
                    <span>Greetings</span>
                  </a>
                </li>
                <li>
                  <a href="/aboutUs/vision">
                    <span>Vision and Core Values</span>
                  </a>
                </li>
                <li>
                  <a href="/aboutUs/history">
                    <span>History</span>
                  </a>
                </li>
                <li>
                  <a href="/aboutUs/map">
                    <span>Map</span>
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <span>Business</span>
              <ul>
                <li>
                  <a href="/business/b-playground">
                    <span>Brain Health Playground</span>
                  </a>
                </li>
                <li>
                  <a href="/business/cogame">
                    <span>Cogame</span>
                  </a>
                </li>
                <li>
                  <span></span>
                </li>
                <li>
                  <span></span>
                </li>
                <li>
                  <span></span>
                </li>
              </ul>
            </li>
            <li>
              <span>Community</span>
              <ul>
                <li>
                  <a href="/community/inform">
                    <span>Inform</span>
                  </a>
                </li>
                <li>
                  <a href="/community/news">
                    <span>News</span>
                  </a>
                </li>
                <li>
                  <a href="/community/hiring">
                    <span>Recruitment</span>
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <span>Support</span>
              <ul>
                <li>
                  <a href="/support/faq">
                    <span>FAQ</span>
                  </a>
                </li>
                <li>
                  <a href="/support/inquiry">
                    <span>Inquiry</span>
                  </a>
                </li>
                {localStorage.length > 0 ? (
                  <li>
                    <a href="/popup">
                      <span>Popup</span>
                    </a>
                  </li>
                ) : null}
              </ul>
            </li>
          </ul>
        </div>
        <div className="menu_bg"></div>
      </header>
      {/* 챗봇 대화창 */}
      {isChabotVisible && (
        <div id="chatbot">
          <div className="chat_header">
            <div className="chat_header_imgWrapper">
              <img src="/images/main_logo2.png" />
            </div>
            <button
              type="button"
              className="chat_close"
              onClick={toggleChatbot}
              aria-label="Close chatbot"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
                <path d="M18 6L6 18M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div className="messages" ref={chatRef}>
            <div className="message bot">
              Hello, this is YoungAnd chatBot.
              <br />
              What are you curious about?
            </div>
            {/* faq질문 */}
            {messages.map((msg, index) => {
              if (msg.title && msg.title.trim() && msg.type != 'faq') {
                return (
                  <div
                    key={index}
                    className="message user question"
                    onClick={() => handleQuestionMessage(msg.title)}
                  >
                    {msg.title}
                  </div>
                );
              }
              return null;
            })}
            {/* 사용자 질문 연출 & 봇의 답변 */}
            {messages.map((msg, index) => {
              if (msg.type != null && msg.type != 'faq') {
                return (
                  <div
                    key={index}
                    className={`message ${msg.type}`}
                    ref={
                      msg.type === "user"
                        ? lastUserMsgRef
                        : null
                    }
                  >
                    {msg.text}
                  </div>
                );
              } else if (msg.type != null && msg.type == 'faq') {
                return (
                  <div
                    key={index}
                    className="message user question"
                    onClick={() => handleQuestionMessage(msg.title)}
                  >
                    {msg.title}
                  </div>
                );
              }
            })}
          </div>
          <div className="input-area">
            <input
              type="text"
              placeholder="Enter your message"
              onKeyPress={(e) => {
                if (e.key === "Enter" && e.target.value.trim() !== "") {
                  handleQuestionAnswer(e.target.value);
                  e.target.value = "";
                }
              }}
            />
            <button
              onClick={() => {
                const input = document.querySelector("#chatbot input").value.trim();
                if (input) {
                  handleQuestionAnswer(input);
                  document.querySelector("#chatbot input").value = "";
                }
              }}
            >
              Send
            </button>
          </div>
        </div>
      )}
      {/* Floating action buttons */}
      <button
        type="button"
        className={`${isChabotVisible ? "showCancel" : null}`}
        id="callChatbot"
        onClick={toggleChatbot}
        aria-label={isChabotVisible ? "Close chatbot" : "Open chatbot"}
        title={isChabotVisible ? "Close" : "Chat with us"}
      >
        {isChabotVisible ? (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        ) : (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            <path d="M8 11h.01M12 11h.01M16 11h.01" />
          </svg>
        )}
      </button>
      <button
        type="button"
        onClick={scrollToTop}
        id="scrollTopBtn"
        aria-label="Scroll to top"
        title="Scroll to top"
        style={bRadius0}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <path d="M18 15l-6-6-6 6" />
        </svg>
      </button>
      <button
        type="button"
        id={`${login != true ? "" : "logoutBtn"}`}
        onClick={handleLogout}
        aria-label="Log out"
        title="Log out"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />
        </svg>
      </button>
    </>
  );
}
